import { Button, createStyles, FormControlLabel, Grid, List, ListItem, ListItemText, makeStyles, Switch, Theme, Tooltip, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { RestricaoConta } from 'enuns/RestricaoConta';
import { ErrorAPI } from 'api/Associado/methods';
import { IAssembleiaAssociadoPauta } from 'store/modules/AssembleiasAssociadoReducer';
import { AxiosError } from 'axios';
import AlertModal, { IAlertModalGenericProps } from 'components/AlertModal/AlertModal';
import GenericModal, { IGenericModalProps } from 'components/GenericModal/GenericModal';
import { ColaboradorIcon, MaletaIcon } from 'components/Icons';
import SyncIcon from 'components/Icons/SyncIcon';
import { AssembleiaContaAssociado } from 'models/AssembleiaContaAssociado';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useDispatch, useSelector } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { assembleiasAssociadoActionsLoadPautas, assembleiasAssociadoActionsRegistrarPresenca } from 'store/modules/AssembleiasAssociadoActions';
import { IAssembleiaAssociadoEvento } from 'store/modules/AssembleiasAssociadoReducer';
import { modalsActionsClose, modalsActionsOpen } from 'store/modules/ModalsActions';
import { ModalsActionsClose } from 'store/modules/ModalsActionTypes';
import { IModalProps } from 'store/modules/ModalsReducer';
import { IReducer } from 'store/Reducer';
import { contaDisponivelParaSelecao, contaSelecionadaPeloUsuario, getTotalContasDisponiveisParaSelecao, getTotalContasSelecionadasPeloUsuario } from 'utils/AssembleiaUtils';
import { getUniqueKey } from 'utils/KeyUtils';
import { useContainerStyles, useContaStyles, useHeadertyles, useItemStyles } from './style';
import AxiosErrorHandler from 'utils/AxiosErrorHandler';

export interface ISeletorContasParaVotoGenericProps extends IGenericModalProps {
  assembleia: IAssembleiaAssociadoEvento,
  cpfCnpj: string,
  onCancel: Function,
  key: string
}

export interface ISeletorContasParaVoto extends IModalProps {
  genericProps?: ISeletorContasParaVotoGenericProps,
  modalsActionsClose: (key: string) => ModalsActionsClose,
  assembleiasAssociadoActionsRegistrarPresenca: (cpfCnpj: string, idsConvocados: number[], assembleiaId: number, callbackSuccess?: () => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => void,
  assembleiasAssociadoActionsLoadPautas: (assembleiaId: number, callbackSuccess?: (pautas: IAssembleiaAssociadoPauta[]) => void, callbackError?: (error: AxiosError<ErrorAPI>) => void) => void,
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridContainer: {
      maxHeight: '70vh',
      overflowX: 'hidden',
      overflowY: 'auto',
    },
    footerRight: {
      textAlign: 'right'
    }
  }),
);

const mapStateToProps = (state:IReducer) => {
  return {
    assembleias: state.assembleias,
    leftMenu: state.leftMenu
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
  modalsActionsClose,
  assembleiasAssociadoActionsRegistrarPresenca,
  assembleiasAssociadoActionsLoadPautas,
}, dispatch);


const SeletorContasParaVotoModal = ({ assembleiasAssociadoActionsLoadPautas, assembleiasAssociadoActionsRegistrarPresenca, genericProps, modalsActionsClose }: ISeletorContasParaVoto) => {
  const [salvando, setSalvando] = useState(false);
  const classes = useStyles();
  const itemClasses = useItemStyles();
  const contaClasses = useContaStyles();
  const containerClasses = useContainerStyles();
  const headerClasses = useHeadertyles();
  const { t } = useTranslation();
  let idConvocados: number[];
  let setIdConvocados: Function;
  [idConvocados, setIdConvocados] = useState([]);
  const [initialized, setInitialized] = useState(false);
  // const [aceiteCheck, setAceiteCheck] = useState(true);
  // const [aceite, setAceite] = useState(1);
  // const [disabledCheckAceite, setDisabledCheckAceite] = useState(false);
  const dispatchAction = useDispatch();
  const { currentEvent } = useSelector((state: IReducer) => state.assembleias);
  const [confirmated, setConfirmated] = useState<boolean>();
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));

  const toClose = () => {
    if (genericProps && genericProps.cpfCnpj) {
      modalsActionsClose(genericProps.key);
    }
  }

  // eslint-disable-next-line
  const toCloseAndShowAlert = (): void => {
    if (genericProps && currentEvent && currentEvent.contasDisponiveis && genericProps.cpfCnpj) {
      const disponiveis: number = getTotalContasDisponiveisParaSelecao(currentEvent.contasDisponiveis, genericProps.cpfCnpj);
      const selecionadas: number = getTotalContasSelecionadasPeloUsuario(currentEvent.contasDisponiveis, genericProps.cpfCnpj);
      if (disponiveis > 0 && selecionadas === 0) {
        // não selecionou nada = aparece
        // abre modal informando que não selecionou nada
        openAlertModal(
          t('AlertModalRepresentante.naoSelecionouNada.title'),
          t('AlertModalRepresentante.naoSelecionouNada.text'),
        );
        modalsActionsClose(genericProps.key);
        return;
      }
      if (disponiveis > 0 && selecionadas > 0) {
        // selecionou mas ainda pode selecionar mais = aparece
        // abre modal informando que ainda pode selecionar mais contas
        openAlertModal(
          t('AlertModalRepresentante.aindaPodeSelecionarMais.title'),
          t('AlertModalRepresentante.aindaPodeSelecionarMais.text'),
        );
        modalsActionsClose(genericProps.key);
        return;
      }
      if (disponiveis === 0) {
        // não tem mais nada para selecionar = não aparece
        toClose();
        return;
      }
    }
  }

  useEffect(() => {
    if (confirmated && currentEvent && currentEvent!.contasDisponiveis && currentEvent!.contasDisponiveis.length > 0) {
      toCloseAndShowAlert();
    }
    // eslint-disable-next-line
  }, [confirmated, currentEvent, currentEvent?.contasDisponiveis, toCloseAndShowAlert])

  const closeConfirmated = () => {
    setConfirmated(true);
    setTimeout(toClose, 1000);
  }

  const getContas = useCallback((): AssembleiaContaAssociado[] => {
    if (genericProps && genericProps.assembleia.contasDisponiveis) {
      return genericProps.assembleia.contasDisponiveis;
    }
    return [];
  }, [genericProps])

  const contaSelecionada = (conta: AssembleiaContaAssociado): boolean => {
    if (genericProps && genericProps.cpfCnpj ) {
      return idConvocados.indexOf(conta.idConvocado) > -1 ? true : false || contaSelecionadaPeloUsuario(conta, genericProps.cpfCnpj);
    }
    return false;
  }

  const handleSelecionarConta = (conta: AssembleiaContaAssociado) => {
    let idConvocadosCopy: number[] = [ ...idConvocados ];
    const idConvocadoFoundIndex: number = idConvocadosCopy.indexOf(conta.idConvocado);
    if (idConvocadoFoundIndex > -1) {
      idConvocadosCopy.splice(idConvocadoFoundIndex, 1);
    } else {
      idConvocadosCopy.push(conta.idConvocado);
    }
    setIdConvocados(idConvocadosCopy);
  }

  const salvarPresencas = () => {
    if (genericProps && genericProps.assembleia && genericProps.cpfCnpj) {
      setSalvando(true);
      assembleiasAssociadoActionsRegistrarPresenca(
        genericProps.cpfCnpj,
        idConvocados,
        genericProps.assembleia.idAssembleia,
        () => {
          assembleiasAssociadoActionsLoadPautas(
            genericProps.assembleia.idAssembleia,
            () => {
              setSalvando(false);
              closeConfirmated()
            },
            error => {
              AxiosErrorHandler(error);
              setSalvando(false);
            }
          );
        },
        error => {
          AxiosErrorHandler(error);
          setSalvando(false);
        }
      );
    }
  }
  
  const contaElegivelParaSelecao = useCallback((conta: AssembleiaContaAssociado): boolean => {
    if (genericProps && genericProps.cpfCnpj) {
      return contaDisponivelParaSelecao(conta, genericProps.cpfCnpj);
    }
    return false;
  }, [genericProps]);

  const contaDisabled = (conta: AssembleiaContaAssociado): boolean => {
    return !contaElegivelParaSelecao(conta);
  }

  useEffect(() => {
    if (!initialized) {
      if (genericProps && genericProps.assembleia && genericProps.assembleia.contasDisponiveis && genericProps.cpfCnpj) {
        let idConvocadosCopy: number[] = [
          ...idConvocados,
          ...genericProps.assembleia.contasDisponiveis.filter(
            (conta: AssembleiaContaAssociado) => {
              // já está selecionado na modal
              if (idConvocados.indexOf(conta.idConvocado) > -1) {
                return false;
              }
              if (!contaDisponivelParaSelecao(conta, genericProps.cpfCnpj) && !contaSelecionadaPeloUsuario(conta, genericProps.cpfCnpj)) {
                return false;
              }
              if (contaDisponivelParaSelecao(conta, genericProps.cpfCnpj)) {
                return true;
              }
              // setDisabledCheckAceite(true)
              // setAceiteCheck(true)
              return false;
            }
          ).map((conta: AssembleiaContaAssociado): number => {
            return conta.idConvocado;
          })
        ];
        setIdConvocados(idConvocadosCopy);
        setInitialized(true);
      }
    }
    // eslint-disable-next-line
  }, [genericProps?.assembleia, initialized, setInitialized, genericProps, genericProps?.cpfCnpj, setIdConvocados, contaElegivelParaSelecao, idConvocados]);

  const openAlertModal = (title: string, text: string) => {
    const modalKey: string = getUniqueKey();
    dispatchAction(
      modalsActionsOpen(
        AlertModal,
        {
          genericProps: {
            title: title,
            contentText: text,
            key: modalKey
          } as IAlertModalGenericProps
        },
        modalKey
      )
    );
  }

  const hasColaborador = useMemo((): boolean => {
    return getContas().filter(
      (conta: AssembleiaContaAssociado): boolean => {
        return conta.flgColaborador
      }
    ).length > 0;
  }, [getContas])

  const hasColaboradorPJ = useMemo((): boolean => {
    return getContas().filter(
      (conta: AssembleiaContaAssociado): boolean => {
        return conta.restricao === RestricaoConta.ColaboradorPJ
      }
    ).length > 0;
  }, [getContas])

  const hasColaboradorMei = useMemo((): boolean => {
    return getContas().filter(
      (conta: AssembleiaContaAssociado): boolean => {
        return conta.restricao === RestricaoConta.ColaboradorMei
      }
    ).length > 0;
  }, [getContas])

  const getRestricaoContaIcon = (restricao: RestricaoConta | null, className: string = '') => {
    switch(restricao) {
    case RestricaoConta.Colaborador:
      return <ColaboradorIcon className={className} />
    case RestricaoConta.ColaboradorPJ:
    case RestricaoConta.ColaboradorMei:
      return <MaletaIcon className={className} />
    default:
      return null;
    }
  }

  const hasRestricao = useMemo((): boolean => {
    return hasColaborador || hasColaboradorPJ || hasColaboradorMei;
  }, [hasColaborador, hasColaboradorPJ, hasColaboradorMei])

  const getText = useCallback((): string => {
    const contas = getContas();
    if (hasRestricao) {
      if (contas.length === 1) {
        return t("SeletorContasParaVotoModal.textos.unicaContaColaborador");
      } else {
        return t("SeletorContasParaVotoModal.textos.temColaboradorNasContas");
      }
    } else {
      if (contas.length > 1) {
        return t("SeletorContasParaVotoModal.textos.somenteNaoColaboradores");
      }
    }
    return '';
  }, [t, getContas, hasRestricao])

  return (
    <GenericModal
      title={ t("SeletorContasParaVotoModal.title")}
      content={(
        <List component="div">
          <Grid container>
            <Grid item xs={12} sm={12} md={12} lg={12} className={headerClasses.aceite}>
              <Typography className={headerClasses.aceiteText} component="p">
                <span dangerouslySetInnerHTML={{ __html: getText() }} />
              </Typography>
            </Grid>
            {
              hasRestricao ? (
                <Grid item xs={12} sm={12} md={12} lg={12} className={headerClasses.switchAceiteRow}>
                  { hasColaborador ? (
                    <Typography className={headerClasses.legendaText} component="p">
                      { getRestricaoContaIcon(RestricaoConta.Colaborador, headerClasses.legendaIcon) }
                      { t("SeletorContasParaVotoModal.legendaColaborador") }
                    </Typography>
                  ) : null }
                  { hasColaboradorPJ ? (
                    <Typography className={headerClasses.legendaText} component="p">
                      { getRestricaoContaIcon(RestricaoConta.ColaboradorPJ, headerClasses.legendaIcon) }
                      { t("SeletorContasParaVotoModal.legendaColaboradorPJ") }
                    </Typography>
                  ) : null }
                  { hasColaboradorMei ? (
                    <Typography className={headerClasses.legendaText} component="p">
                      { getRestricaoContaIcon(RestricaoConta.ColaboradorMei, headerClasses.legendaIcon) }
                      { t("SeletorContasParaVotoModal.legendaColaboradorMei") }
                    </Typography>
                  ) : null }
                </Grid>
              ) : null
            }
          </Grid>
          <ListItem className={headerClasses.root}>
            <Grid container>
              <Grid item xs={4} sm={2} className={headerClasses.text}>
                { t("SeletorContasParaVotoModal.headerTextConta") }
              </Grid>
              <Grid item xs={8} sm={6} className={headerClasses.text}>
              { t("SeletorContasParaVotoModal.headerTextNomAsso") }
              </Grid>
              {
                isDesktop ? (
                  <Grid item xs={3} sm={3} className={headerClasses.textPresença}>
                    { t("SeletorContasParaVotoModal.headerTextPresen") }
                  </Grid>
                ) : null
              }
            </Grid>
          </ListItem>
          {
            initialized === true ? getContas().map((conta: AssembleiaContaAssociado, key: number) => {
              return (
                <Tooltip title={ `${ conta.numeroConta } ⠀ ${ conta.nomeAssociado }` } arrow key={key}>
                  <ListItem
                    button
                    classes={containerClasses}
                    disabled={ contaDisabled(conta) }
                    onClick={() => handleSelecionarConta(conta)}
                  >
                    <ListItemText
                      primary={(
                        <Grid container>
                          <Grid item xs={4} sm={3} className={contaClasses.numeroConta}>
                            { conta.numeroConta }
                          </Grid>
                          <Grid item xs={8} sm={9} className={contaClasses.nomeAssociado}>
                            {
                              getRestricaoContaIcon(conta.restricao, String(contaClasses.colaboradorIcon))
                            }
                            { conta.nomeAssociado }
                          </Grid>
                        </Grid>
                      )}
                      primaryTypographyProps={{
                        component: 'span',
                      }}
                      secondary={(
                        <FormControlLabel
                          labelPlacement="start"
                          label={ isDesktop ? t(`SeletorContasParaVotoModal.confirm${contaSelecionada(conta) ? 'ed' : ''}DesktopLabel`) : t(`SeletorContasParaVotoModal.confirm${contaSelecionada(conta) ? 'ed' : ''}MobileLabel`)}
                          control={(
                            <Switch
                              color="primary"
                              checked={ contaSelecionada(conta) }
                              onChange={
                                (event: React.ChangeEvent<HTMLInputElement>) => {
                                  handleSelecionarConta(conta)
                                }
                              }
                              name="gilad"
                              disabled={ salvando || contaDisabled(conta) } />
                          )}
                          />
                      )}
                      secondaryTypographyProps={{
                        component: 'span',
                      }}
                      classes={itemClasses}
                    />
                  </ListItem>
                </Tooltip>
            )}) : null
          }
        </List>
      )}
      genericProps={{
        maxWidth: 'sm',
        onClose: closeConfirmated,
        footerContent: (
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} className={ classes.footerRight }>
              <Button
                variant="contained"
                color="primary"
                onClick={ salvarPresencas }
                disabled={ salvando || idConvocados.length === 0 }
                endIcon={salvando ? <SyncIcon className="animation-rotate" /> : null}
                >{ t("SeletorContasParaVotoModal.confirmLabel") }</Button>
            </Grid>
          </Grid>
        )
      }}
      />
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(SeletorContasParaVotoModal);